module.exports = __webpack_public_path__ + "img/cw.a5487f56.svg";